var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnnotations = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.027 10.074V0H3.973v10.077l3.021-2.053zM4.973 8.188V1h4.055v7.191L6.991 6.815zM16 1.007V16H1V1.007h1.974v1H2V15h13V2.007h-4.005v-1z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnnotations);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/annotations.svg";